// @flow
import type { Dispatch } from 'redux';
import { isNumber } from 'lodash';

import { API_CALL, RESET_FRIENDS, VIEW_FRIEND } from '../constants/actionTypes';
import * as friendsApi from '../api/friends';
import * as friendRequestsApi from '../api/friendRequests';

import { FRIENDS, REMOVE_FRIEND, UPDATE_FRIEND_GROUPS } from '../constants/apiTypes';

export function fetchFriends() {
  return {
    type: API_CALL,
    api: FRIENDS,
    request: Promise.all([friendsApi.getFriends(), friendRequestsApi.getFriendRequests()]).then(
      results => ({
        friends: results[0].data,
        friendRequests: results[1].data
      })
    )
  };
}

export function viewFriend(friend?: Friend | FriendRequest | User | number) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const state = getState();
    let friendObj = friend;
    if (isNumber(friend)) {
      friendObj = state.friends.friends[friend] || state.friendRequests.friendRequests[friend];
    }
    dispatch({
      type: VIEW_FRIEND,
      friend: friendObj
    });
  };
}

export function resetFriends() {
  return (dispatch: Dispatch<*>) => {
    dispatch({
      type: RESET_FRIENDS
    });
  };
}

// unfriend
export function removeFriend(friendId: number) {
  return {
    type: API_CALL,
    api: REMOVE_FRIEND,
    request: friendsApi.removeFriend(friendId).then(() => ({
      friendId
    }))
  };
}

/**
 *
 * @param {*} friendId
 * @param {*} groupsToAdd
 * @param {*} groupsToRemove
 */
export function updateFriendGroups(
  friendId: number,
  groupsToAdd: Array<number> = [],
  groupsToRemove: Array<number> = []
) {
  let addPromise = Promise.resolve();
  let removePromise = Promise.resolve();

  if (groupsToAdd.length > 0) {
    addPromise = friendsApi.addFriendToGroups(friendId, groupsToAdd);
  }
  if (groupsToRemove.length > 0) {
    removePromise = friendsApi.removeFriendFromGroups(friendId, groupsToRemove);
  }

  return {
    type: API_CALL,
    api: UPDATE_FRIEND_GROUPS,
    friendId,
    groupIds: [...groupsToAdd, ...groupsToRemove],
    request: Promise.all([addPromise, removePromise]).then(() => ({
      friendId,
      removedGroups: groupsToRemove,
      addedGroups: groupsToAdd
    }))
  };
}
